import { Form } from 'rsuite';
import React from 'react';
import { TextStyleProps } from 'types';
import { buildFormLabelStyle } from 'lib/buildTextStyle';
import styles from './FormControlLabel.module.scss';

type FormControlLabelProps = {
  required?: boolean;
  children: string | string[];
} & TextStyleProps;

export default function FormControlLabel({
  required = false,
  children,
  ...rest
}: FormControlLabelProps) {
  return (
    <Form.ControlLabel
      className={styles.label}
      style={buildFormLabelStyle(rest)}
    >
      {children} {required && <span className={styles.asterisk}>*</span>}
    </Form.ControlLabel>
  );
}
